/** Copyright © 2013-2022 DataYes, All Rights Reserved. */

import React from 'react';
import { Popover } from 'antd';
import qrcode from '../../images/qrcode.png';

export default function DownloadApp() {
  return (
    <Popover
      placement="bottom"
      content={
        <div>
          <img style={{ width: 150 }} src={qrcode} alt="qrcode" />
          <p>扫一扫下载萝卜投研APP</p>
        </div>
      }
    >
      <span className="header-icon">下载APP</span>
    </Popover>
  );
}
